module.exports = __webpack_public_path__ + "img/alegere-din-toata-psaltirea-1769-pagina-de-titlu-big.f755e867.jpg";